export default __webpack_public_path__ + "static/SRF 0100 - Product Specifications & Technical Data-2b7e34f8627d81cd4251a73f97b11bf1.pdf";